import clx from 'classnames';
import { ReactNode } from 'react';
import MainTitle from '@/molecules/titles/MainTitle';
import { ALIGNMENT_ENUM } from 'types/utils';

const ALIGNMENT_TO_CLASSNAME = {
  [ALIGNMENT_ENUM.left]: 'items-start',
  [ALIGNMENT_ENUM.center]: 'items-center',
  [ALIGNMENT_ENUM.right]: 'items-right',
};

const PageLeading = ({
  children,
  alignment = ALIGNMENT_ENUM.left,
  title,
}: {
  children?: ReactNode[] | ReactNode;
  alignment?: ALIGNMENT_ENUM;
  title?: string | null;
}) => (
  <div className={clx('mb-4 flex flex-col gap-4', ALIGNMENT_TO_CLASSNAME[alignment])}>
    {title && (
      <div className="relative w-full">
        <div className="flex flex-col justify-center items-center w-full gap-1 mb-4">
          <MainTitle alignment={ALIGNMENT_ENUM.center}>{title}</MainTitle>
          <picture>
            <source media="(min-width: 768px)" srcSet="/divider-md.png" />
            <img alt="" src="/divider-sm.png" />
          </picture>
        </div>
      </div>
    )}
    {children}
  </div>
);

export default PageLeading;
